import React, { useState, useEffect } from 'react';
import { Dropdown, Row, Col, DropdownButton, Form } from 'react-bootstrap';
import { FlightBoundaryMap } from './FlightBoundaryMap';
import OrdersApiClient from '../../../../../apiClient/OrdersApiClient';
import { useInvalidateAllOrders } from '../../../../../hooks/useOrders';

/**
 * Allows for the editing of an order's inspection's flight boundaries.
 * @param {*} order - currently selected order
 * @param {*} orderActions - suite of redux actions for the order
 * @param {*} solarFarm - farm associated with the currently selected order
 */
const FlightBoundaryTab = ({ order, orderActions, solarFarm }) => {
  const [selectedInspection, setSelectedInspection] = useState(null);
  const [uploadSessions, setOrderUploadSessions] = useState([]);
  const { invalidateAllOrders } = useInvalidateAllOrders(order.uuid);
  const [flightBoundary, setFlightBoundary] = useState(
    order.inspections[0]?.flight_boundary ?? null,
  );

  useEffect(() => {
    handleFetchUploadSessions();
    if (order?.inspections?.[0]) {
      setSelectedInspection(order.inspections[0]);
    }
  }, [order]);

  /**
   * Launch api call to update boundary geojson
   * @param {*} boundaryGeojson
   */
  const updateInspectionFlightBoundary = boundaryGeojson => {
    if (
      order &&
      selectedInspection &&
      selectedInspection.flight_boundary !== boundaryGeojson
    ) {
      orderActions.updateInspectionFlightBoundary(
        order.uuid,
        selectedInspection.uuid,
        boundaryGeojson,
      );
      invalidateAllOrders();
    }
  };

  /**
   * Fetch Order Upload Sessions for the current order
   */
  const handleFetchUploadSessions = () => {
    const ordersApi = new OrdersApiClient();

    ordersApi
      .getOrderUploadSessions(order.uuid)
      .then(orderUploadSessions => setOrderUploadSessions(orderUploadSessions));
  };

  return (
    <Row style={{ paddingTop: '30px' }}>
      <Col sm={10}>
        <Row>
          <Col>
            <Form.Group>
              <Form.Label>Inspection:</Form.Label>
              <DropdownButton
                id="dropdown-basic-button"
                title={
                  (selectedInspection && selectedInspection.name) ||
                  'Select Inspection'
                }
                variant="primary"
              >
                {order &&
                  order.inspections &&
                  order.inspections.map(inspection => (
                    <Dropdown.Item
                      onClick={() => {
                        setSelectedInspection(inspection);
                        setFlightBoundary(inspection.flight_boundary ?? null);
                      }}
                      key={inspection.name}
                    >
                      {inspection.name}
                    </Dropdown.Item>
                  ))}
              </DropdownButton>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <FlightBoundaryMap
            solarFarm={solarFarm}
            boundary={flightBoundary}
            zoneBoundaries={order?.zones?.map(zone => zone.geom)}
            onBoundaryUpdate={boundaryGeojson => {
              setFlightBoundary(boundaryGeojson);
              updateInspectionFlightBoundary(boundaryGeojson);
            }}
          />
        </Row>
      </Col>
    </Row>
  );
};

export default FlightBoundaryTab;
